@if (modelDescription) {
<div class="row mt-3">
    <div class="col-3">
        <div class="field mb-3"> 
            <label>Model:</label>
            <p class="pt-2">{{ modelDescription }}</p>
        </div>
    </div>
    @if (serialNumber) {
<div class="col-3">
        <div class="field mb-3"> 
            <label>Serial Number:</label>
            <p class="pt-2">{{ serialNumber }}</p>
        </div>
    </div>
}
</div>
}

<div class="mb-2">
    <div class="row">
        <div class="col tabbable-line pt-1">
            <ul class="nav nav-tabs border-bottom" id="tabs">
                <li class="nav-item">
                    <a 
                        class="nav-link active position-relative" 
                        data-bs-toggle="tab" 
                        href="#service-order-tab"
                        title="Service Order History"
                    >Service Order</a>
                </li>
                <li class="nav-item">
                    <a 
                        class="nav-link position-relative" 
                        data-bs-toggle="tab" 
                        href="#equipments-tab"
                        title="Equipment History"
                    >Equipment</a>
                </li>
            </ul>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="tab-content flex-fill mt-2">
                <div class="tab-pane active show" id="service-order-tab">
                    @if (hasHistory && serviceOrderGridConfig) {
<div class="service-order-grid">
                        <inavista-grid #serviceOrdersGrid class="so-popup-grid"
                            [config]="serviceOrderGridConfig"
                            (exportRequested)="onServiceOrderHistoryExport()" />
                    </div>
}
                </div>
                <div class="tab-pane" id="equipments-tab">
                    @if (equipmentGridConfig) {
<div class="equipments-grid">
                        <inavista-grid #equipmentsGrid class="so-popup-grid"
                            [config]="equipmentGridConfig"
                            (hyperlinkClick)="onEquipmentHyperlinkClick($event)"
                            (exportRequested)="onEquipmentHistoryExport()" />
                    </div>
}
                </div>
            </div>
        </div>
    </div>
</div>

@if (showPopup) {
<app-popup
   
    [id]="serviceOrderId"
    [data]="serviceOrderData"
    (onClose)="showPopup = false"
></app-popup>
}
